import { render } from "./IconTurnLeft.vue?vue&type=template&id=0b2a2da0"
import script from "./IconTurnLeft.vue?vue&type=script&lang=js"
export * from "./IconTurnLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__